import { MaintenanceWindowFormController } from '../controller/MaintenanceWindowFormController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class MaintenanceWindowFormWebComponent extends BaseWebComponentElement {
  public controller: MaintenanceWindowFormController | null;
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MaintenanceWindowFormController,
    });
  }

  get isVisible(): boolean | undefined {
    if (this.hasAttribute('data-is-visible')) {
      const value = this.getAttribute('data-is-visible');
      return value ? JSON.parse(value) : undefined;
    }
    return undefined;
  }

  set isVisible(value: boolean | undefined) {
    if (value) {
      this.setAttribute('data-is-visible', '');
    } else {
      this.removeAttribute('data-is-visible');
    }
  }

  // getter/setter for maintenanceWindowsId
  get maintenanceWindowId(): string | undefined {
    if (this.hasAttribute('data-maintenance-window-id')) {
      const value = this.getAttribute('data-maintenance-window-id');
      return value ?? '';
    }
    return undefined;
  }

  set maintenanceWindowId(value: string | undefined) {
    if (typeof value === 'undefined') {
      this.removeAttribute('data-maintenance-window-id');
    } else {
      this.setAttribute('data-maintenance-window-id', value);
    }
    // trigger getDataForView
    this.controller?.render();
  }

  get maintenanceWindowType(): string | undefined {
    if (this.hasAttribute('data-maintenance-window-type')) {
      const value = this.getAttribute('data-maintenance-window-type');
      return value ?? '';
    }
    return undefined;
  }

  set maintenanceWindowType(value: string | undefined) {
    if (typeof value === 'undefined') {
      this.removeAttribute('data-maintenance-window-type');
    } else {
      if (this.maintenanceWindowType === value) {
        // Debounce value change
        return;
      }
      this.setAttribute('data-maintenance-window-type', value);
    }
    this.controller?.render();
  }
}
